import { V2PaymentPrepareRequest, V2PaymentResponse } from '@api';
import { Stripe } from '@stripe/stripe-js';
import { Create, Request } from 'src/js/common/epics/EpicUtils';
import { CHECKOUT_PROCESS_STRIPE_CC_PAYMENT } from 'src/js/enrol/containers/payment/actions/Actions';
import CheckoutApiService from 'src/js/enrol/services/CheckoutApiService';
import CheckoutService, { BuildCheckoutModelRequest } from 'src/js/enrol/services/CheckoutService';
import { IshState } from 'src/js/services/IshState';

const request: Request<V2PaymentResponse, { stripePaymentMethodId: string, stripe: Stripe }> = {
  type: CHECKOUT_PROCESS_STRIPE_CC_PAYMENT,
  getData: async ({ stripePaymentMethodId, stripe }, state: IshState) => {

    const paymentRequest: V2PaymentPrepareRequest = {
      checkoutModelRequest: await BuildCheckoutModelRequest.fromState(state),
      storeCard: false,
      ccAmount: state.checkout.amount.ccPayment,
    };

    const sessionResponse = await CheckoutApiService.createSession(
      paymentRequest,
      state.checkout.payerId,
      state.checkout.payment.sessionId
    )

    const checkoutResponse = await CheckoutApiService.submitCreditCardPayment(
      {
        merchantReference: sessionResponse.merchantReference,
        paymentSystemMethodId: stripePaymentMethodId,
        onCourseSessionId: sessionResponse.sessionId
      },
      state.checkout.payerId
    )

    if (checkoutResponse.actionRequired) {
      const {
        error,
      } = await stripe.handleCardAction(checkoutResponse.clientSecret);

      if (error) {
        throw error;
      }
    }

    return checkoutResponse;
  },
  processData: (response: V2PaymentResponse) => CheckoutService.processPaymentResponse(response),
  processError: CheckoutService.prcessPaymentError
};

export const EpicStripePayment = Create(request);